"use client";

import { useState, useEffect } from "react";

/**
 * Returns true immediately when value becomes true, but lingers
 * for `delay` ms before returning false after value goes false.
 */
export function useLingeringValue(value: boolean, delay: number): boolean {
  const [lingering, setLingering] = useState(value);

  useEffect(() => {
    if (value) {
      setLingering(true);
      return;
    }
    const timeout = setTimeout(() => setLingering(false), delay);
    return () => clearTimeout(timeout);
  }, [value, delay]);

  return value || lingering;
}
